import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useUpdateDelivery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (...args: Parameters<typeof API.deliveries.updateDelivery>) => API.deliveries.updateDelivery(...args),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([QueryKeys.Delivery]),
        queryClient.invalidateQueries([QueryKeys.Deliveries]),
        queryClient.invalidateQueries([QueryKeys.Order]),
        queryClient.invalidateQueries([QueryKeys.TimeStamps]),
      ]),
  });
};
